<div class="col-12 success-item" [style]="{'color':fontColor}">
    <div class="col-12"
         style="height: 40%;position: relative;background: linear-gradient(360deg, {{backColor}} 0%, #ffffff00 100%);">
        <div style=" width: 100%;
    height: 100%;
    position: absolute;
    background: linear-gradient(360deg, {{backColor}} 0%, #ffffff00 100%);
    z-index: 1;"></div>
        <img draggable="false" class="logo" src="{{logoPath}}">
        <img draggable="false" class="image" src="{{backImage}}">
    </div>
    <div  [style]="{'height': '60%','position': 'relative','background-color': backColor ,'border-radius': '0px 0px 10px 10px'}">
        <h2 #tit class="title">
            {{title}}
        </h2>
        <p class="text" style="{{'height: calc(100% - '+(tit.offsetHeight+90)+'px)'}}">
            {{text}}
        </p>
        <div class="more-div">
            <button class="button more-btn" (click)="goToPage()"><span i18n="@@Full story">Full story</span>
                <i *ngIf="getDirection()=='rtl'" class="pi pi-angle-left"></i>
                <i *ngIf="getDirection()=='ltr'" class="pi pi-angle-right"></i>
            </button>
        </div>
    </div>

</div>
